import styled from 'styled-components';
import _get from 'lodash/get';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

import CommonReelButton from '../../containers/ReelButton';

const ReelButton = styled(CommonReelButton).attrs((props) => ({
    iconName: props.mediaPlayback.isInReel ? 'delete-reel' : 'add-reel',
    iconSize: 28,
    iconColor: COLORS.mlbGrey3,
    size: 'md',
    styleName: 'default',
    shape: 'hollow-borderless',
    hasHover: false,
    ...props,
}))`
    padding: 0px;
    max-width: 100%;
    text-align: left;
    white-space: nowrap;

    span {
        vertical-align: middle;
    }

    ${IconWrapper} {
        vertical-align: middle;
        stroke: none;
    }
`;

export default ReelButton;
